export const APP_NAME = 'fe-learner-catalog';
export const FEEDBACK_UI = 'core.feedback.ui';
export const TW_ROOT = 'fe-learner-catalog-root-tw';
